const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || '').replace(/\/$/, '');

export async function apiFetch(path, options = {}) {
  const token = localStorage.getItem('auth_token');
  const headers = {
    'Content-Type': 'application/json',
    ...(options.headers || {}),
  };

  if (token && !headers.Authorization) {
    headers.Authorization = `Bearer ${token}`;
  }

  const url = path.startsWith('/api/')
    ? `${API_BASE_URL}${path}`
    : `${API_BASE_URL}/api${path.startsWith('/') ? '' : '/'}${path}`;

  const resp = await fetch(url, {
    ...options,
    headers,
  });

  const text = await resp.text();
  const data = text ? JSON.parse(text) : null;

  if (!resp.ok) {
    const message = data?.error || `Request failed (${resp.status})`;
    const err = new Error(message);
    err.details = data?.details;
    throw err;
  }

  return data;
}
